import { deprecated } from "typesafe-actions";

import type { IStatusError } from "@/shop/types/errors";
import type { IRfqTransaction } from "@/shop/types/shopping/rfq";

const { createStandardAction } = deprecated;

/** Fetch rfq transaction */
export const fetchRfqList = createStandardAction("FETCH_RFQ_LIST")();

export const fetchRfqListStart = createStandardAction("FETCH_RFQ_LIST_START")();

export const fetchRfqListSuccess = createStandardAction("FETCH_RFQ_LIST_SUCCESS").map((payload: IRfqTransaction[]) => ({
  payload
}));

export const fetchRfqListFail = createStandardAction("FETCH_RFQ_LIST_FAIL").map((payload: IStatusError) => ({
  payload,
  error: true
}));

export const removeRfqListItem = createStandardAction("REMOVE_RFQ_LIST_ITEM").map((payload: string) => ({
  payload
}));

export const removeAllRfqListItems = createStandardAction("REMOVE_ALL_RFQ_LIST_ITEMS")();
